import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LabelClient } from '@core/api/proxy';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-download-qr-urls',
  template: ` <button class="vl-button vl-u-align-right" (click)="downloadQRUrlCsv()">{{ 'DOWNLOAD.QRCODE_URLS' | translate }}</button> `,
  styleUrls: ['./download-qr-urls.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadQrUrlsComponent {
  private labelClient = inject(LabelClient);
  downloadQRUrlCsv() {
    this.labelClient.downloadQRUrls().subscribe((result) => {
      saveAs(result.data, `QRCodeUrls.csv`);
    });
  }
}
